export const SELECT_PUBLISHER = "SELECT_PUBLISHER";
export const FETCH_PUBLISHERS = "FETCH_PUBLISHERS";
export const FETCH_PUBLISHER = "FETCH_PUBLISHER";
export const FETCH_PUBLISHER_COUNTRY_INFO = "FETCH_PUBLISHER_COUNTRY_INFO";
export const FETCH_PUBLISHER_DEMOGRAPHICS_INFO =
  "FETCH_PUBLISHER_DEMOGRAPHICS_INFO";
export const FETCH_PUBLISHER_TECHNOLOGY_INFO =
  "FETCH_PUBLISHER_TECHNOLOGY_INFO";
